import React from 'react';
import BannerAnim from 'rc-banner-anim';
import styles from './slide_rec.css';
import Book from '../book';
import env from '../../lib/env';

const { Element } = BannerAnim;
const BgElement = Element.BgElement;

export default class SlideRec extends React.Component {

	state = {
		cur_idx: 0,
	}

	banner = null;
	
	change = (type, cur_idx) => {
		if (type === 'before') {
			this.setState({cur_idx});
		}
	};

	jump = idx => {
		if (this.banner) {
			this.banner.slickGoTo(idx);
		}
	}

    render() {
        const data = this.props.data.slice(0, 4);
        const cur_book = data[this.state.cur_idx];
        return (
		<div>
			<div style={{position: 'relative'}}>
				<BannerAnim
					prefixCls={styles.anim_body}
					ref={(c) => { this.banner = c; }}
					arrow={false}
					thumb={false}
					autoPlay
					autoPlaySpeed={5000}
					onChange={this.change}
				>
				{data.map((item, idx) => (
					<Element
						onClick={() => env.goto_page(`/book/detail/${item.novel_id}`)}
						key={idx} prefixCls={styles.anim_element}>
						<BgElement
							key="bg"
							className={styles.bg}
							style={{
								backgroundImage: `url(${item.pic})`,
								backgroundSize: 'cover',
								backgroundPosition: 'center',
								cursor: 'pointer'
							}}
						/>
					</Element>
				))
				}
				</BannerAnim>
				<div className={styles.thumb}>
				{data.map((item, idx) => (
					<div
						key={idx}
						style={{
							backgroundImage: `url(${item.pic})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							cursor: 'pointer'
						}}
						className={this.state.cur_idx === idx ? styles.active : styles.inactive}
						onClick={() => this.jump(idx)}
					/>
				))
				}
				</div>
			</div>
			<div style={{marginTop: '30px'}}>
            {cur_book && <Book template='brief_2' {...cur_book}/>}
			</div>
		</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/rec/slide_rec.js